function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopulae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "581.000000pt",
    height: "195.000000pt",
    viewBox: "0 0 300.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.050963, 0, 0, -0.050963, -1.879194, 100.49823)",
    fill: "#000000",
    stroke: "none",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703 1856 c-60 -19 -122 -58 -196 -121 l-64 -54 -6 71 c-3 39 -11 76 -17 82 -13 13 -234 15 -247 3 -9 -10 -17 -1541 -8 -1606 4 -26 16 -53 30 -67 22 -22 28 -23 122 -18 54 3 108 7 120 10 43 8 48 34 53 311 l5 262 55 -46 c92 -77 124 -87 280 -87 129 -1 138 0 195 28 152 74 259 256 285 483 11 100 -3 327 -26 416 -35 134 -128 255 -240 312 -50 25 -68 28 -177 32 -85 2 -135 -1 -164 -11z m142 -285 c68 -39 121 -164 131 -309 16 -227 -83 -392 -235 -392 -68 0 -84 8 -173 85 l-78 66 0 203 0 203 63 60 c113 108 204 135 292 84z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4075 1500 l-30 -5 -3 -498 -2 -497 90 0 90 0 0 488 c0 268 -4 492 -8 499 -9 14 -92 22 -137 13z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2639 1347 c-31 -13 -83 -43 -115 -66 l-59 -41 -3 39 c-4 56 -29 74 -101 75 -104 2 -96 50 -96 -589 0 -507 1 -556 17 -571 13 -14 34 -17 104 -15 48 0 90 4 93 7 3 2 8 89 12 192 4 103 7 188 8 190 0 2 22 -12 48 -29 99 -68 209 -80 312 -33 137 61 204 198 205 419 1 123 -13 192 -55 276 -54 108 -127 158 -243 165 -59 4 -80 1 -127 -19z m107 -196 c18 -11 41 -40 55 -67 20 -42 23 -63 22 -159 0 -131 -16 -180 -73 -225 -64 -51 -120 -40 -206 41 l-54 52 0 106 c0 138 10 171 63 215 73 60 136 72 193 37z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1201 c-66 -12 -146 -61 -186 -115 -55 -73 -74 -141 -74 -267 0 -101 2 -109 35 -175 57 -111 149 -164 286 -164 216 0 334 101 364 312 25 177 -48 340 -175 387 -60 22 -187 34 -250 22z m163 -163 c51 -32 72 -85 72 -190 0 -147 -41 -207 -147 -216 -46 -4 -58 -1 -89 23 -50 38 -64 78 -64 182 1 121 29 190 85 214 39 15 106 10 143 -13z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4570 1200 c-68 -12 -102 -28 -137 -63 -26 -24 -33 -39 -33 -68 0 -60 18 -66 108 -35 104 35 202 36 236 3 21 -22 42 -99 31 -116 -2 -5 -48 -11 -101 -15 -218 -16 -304 -79 -304 -220 0 -69 32 -132 88 -171 41 -28 49 -30 135 -29 91 1 173 23 191 53 10 15 26 14 26 -3 0 -23 23 -34 89 -42 l64 -7 -5 284 c-5 308 -7 316 -65 371 -15 15 -44 34 -64 42 -44 18 -197 28 -259 16z m208 -459 c4 -49 -15 -84 -56 -105 -77 -39 -143 -27 -162 29 -22 68 15 108 109 116 104 9 106 8 109 -40z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5360 1200 c-154 -31 -250 -178 -250 -381 0 -116 35 -205 105 -267 59 -52 106 -63 271 -63 111 0 141 3 178 20 38 16 46 25 51 55 10 49 -1 86 -24 86 -11 0 -55 -7 -98 -15 -188 -36 -278 2 -286 121 l-2 39 215 6 c118 3 216 7 216 7 1 1 4 20 8 42 8 52 -9 162 -34 210 -57 111 -204 171 -350 140z m122 -130 c30 -9 41 -19 62 -62 43 -86 41 -88 -112 -88 -126 0 -137 5 -122 46 25 64 69 103 130 113 3 1 22 -4 42 -9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3248 1193 c-25 -6 -31 -113 -20 -358 11 -242 18 -269 83 -312 38 -25 53 -28 141 -31 l99 -4 63 41 c34 23 65 41 69 41 4 0 7 -10 7 -23 0 -36 19 -47 86 -47 l62 0 7 145 c9 181 2 522 -10 534 -11 10 -53 15 -121 12 l-41 -1 -6 -227 c-8 -256 -5 -247 -95 -300 -55 -33 -101 -26 -134 20 -22 30 -23 43 -28 260 -5 212 -6 230 -24 243 -19 13 -99 18 -138 7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulae);
export default __webpack_public_path__ + "static/media/populae.e049347aff7e1172224e4d5b20a2da11.svg";
export { ForwardRef as ReactComponent };